module.exports = __webpack_public_path__ + "static/media/banner_dashboard.e27f922c.png";